/**
 * Tax classification of a trip reason for the customs logbook audit.
 *
 * - `favored`: steuerlich begünstigt (green on the map)
 * - `notFavored`: nicht begünstigt (blue on the map)
 * - `none`: no assignment (grey on the map)
 */
export type ReasonTaxClass = "favored" | "notFavored" | "none";

export const REASON_TAX_CLASSES: readonly ReasonTaxClass[] = ["favored", "notFavored", "none"];

/** Suffix the EcoApp appends to reasons that were recorded in a paper logbook. */
export const MANUAL_ENTRY_SUFFIX = "(Manueller Eintrag)";

/**
 * Default assignment of trip reasons to tax classes, as agreed with the customer.
 * Keys are the raw reason names from the "Access Logbook" group description; matching is
 * done on the normalized form (see `normalizeReason`).
 */
export const DEFAULT_FAVORED_REASONS: readonly string[] = [
  "Linien-/ Schul-/ Berufsverkehr",
  "Schienenersatz-/ Bus Notverkehr",
  "Werkstatt- / Schulungs- / Überführungsfahrt",
];

export const DEFAULT_NOT_FAVORED_REASONS: readonly string[] = [
  "Fahrschulfahrt",
  "Werk-/ Gelegenheitsverkehr",
  "Fernlinie (Haltestellenabstand > 50km)",
  "Dienstfahrt (Pkw)",
];

/** AddInData `dataType` of the per-database override record (see spec 12.4). */
export const REASON_TAX_CLASS_DATA_TYPE = "logbookAuditReasonTaxClasses";
